export default __webpack_public_path__ + "static/media/Perrito.37e41d6e.png";